import { Box, Flex } from "@chakra-ui/react";
import { useState } from "react";
import Header from "../components/header/header";
import { SettingsMenuItem } from "../components/settings/costants";
import SettingsAutomaticBookings from "../components/settings/settings-automatic-bookings";
import SettingsCourts from "../components/settings/settings-courts";
import SettingsGeneral from "../components/settings/settings-general";
import SettingsMenu from "../components/settings/settings-menu";
import SettingsPrices from "../components/settings/settings-prices";
import SettingsServiceHours from "../components/settings/settings-service-hours";

const SettingsPage = () => {
  const [activeSection, setActiveSection] = useState(SettingsMenuItem.GENERAL);

  return (
    <Box flexDirection="column">
      <Header />

      <Flex h="calc(100vh - 72px)">
        <SettingsMenu onSelect={item => setActiveSection(item)} />

        {/* Main content */}
        <Box flex="1" p={6} overflow="auto">
          {activeSection === SettingsMenuItem.GENERAL && <SettingsGeneral />}
          {activeSection === SettingsMenuItem.COURTS && <SettingsCourts />}
          {activeSection === SettingsMenuItem.PRICES && <SettingsPrices />}
          {activeSection === SettingsMenuItem.SERVICE_HOURS && <SettingsServiceHours />}
          {activeSection === SettingsMenuItem.AUTOMATIC_BOOKINGS && <SettingsAutomaticBookings />}
        </Box>
      </Flex>
    </Box>
  );
};

export default SettingsPage;
